// https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow
// https://docs.microsoft.com/en-us/azure/active-directory-b2c/code-samples

import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_AZURE_B2C_CLIENT_ID;
if (!clientId) {
  throw new Error("Azure B2C client ID not set");
}

const tenantSubdomain = process.env.REACT_APP_AZURE_B2C_SUBDOMAIN;
if (!tenantSubdomain) {
  throw new Error("Azure B2C tenant subdomain not set");
}

const signInPolicy = process.env.REACT_APP_AZURE_B2C_SIGN_IN_POLICY;
if (!signInPolicy) {
  throw new Error("Azure B2C sign in policy not set");
}

const forgotPaswordPolicy = process.env.REACT_APP_AZURE_B2C_FORGOT_PASSWORD_POLICY;
if (!forgotPaswordPolicy) {
  throw new Error("Azure B2C forgot password policy not set");
}

const editProfilePolicy = process.env.REACT_APP_AZURE_B2C_EDIT_PROFILE_POLICY;
if (!editProfilePolicy) {
  throw new Error("Azure B2C edit profile policy not set");
}

const tenant = `${tenantSubdomain}.onmicrosoft.com`;
const instance = `https://${tenantSubdomain}.b2clogin.com/tfp/`;
const authority = `${instance}${tenant}/${signInPolicy}`;

export const scopes = [clientId, "openid", "offline_access"];

export const b2cPolicies = {
  names: {
    signUpSignIn: signInPolicy,
    forgotPassword: forgotPaswordPolicy,
    editProfile: editProfilePolicy
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${tenantSubdomain}.b2clogin.com/${tenantSubdomain}.onmicrosoft.com/${signInPolicy}`,
      scopes,
    },
    forgotPassword: {
      authority: `https://${tenantSubdomain}.b2clogin.com/${tenantSubdomain}.onmicrosoft.com/${forgotPaswordPolicy}`,
      scopes,
    },
    editProfile: {
      authority: `https://${tenantSubdomain}.b2clogin.com/${tenantSubdomain}.onmicrosoft.com/${editProfilePolicy}`,
      scopes,
    },
  },
  authorityDomain: `${tenantSubdomain}.b2clogin.com`,
}

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    authority,
    knownAuthorities: [authority],
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const msalInstance = new PublicClientApplication(configuration);

export const acquireAccessToken = async () => {
  // TODO: This always requests a token via network - investigate why tokens are not provided from cache

  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();
  const account = activeAccount ?? accounts[0];

  const authResult = await msalInstance.acquireTokenSilent({
    scopes,
    account,
  });

  if (!authResult.accessToken) {
    throw new Error("Access token not found");
  }

  return authResult.accessToken;
};

export default msalInstance;
